//#region src/utils/get-os.ts
var e = () => {
	if (typeof window > "u") return;
	if (navigator.userAgentData?.platform) return navigator.userAgentData.platform;
	let e = navigator.userAgent.toLowerCase();
	if (e.includes("mac")) return "macOS";
	if (e.includes("win")) return "Windows";
	if (e.includes("linux")) return "Linux";
};
//#endregion
export { e as getOS };
